import React, {FC, memo} from "react";

type LessonBookingBadgeProps = {margin?: [number, number]; style?: React.CSSProperties};

const LessonBookingBadge: FC<LessonBookingBadgeProps> = ({margin = [0, 0], style: styleProps}) => {
    const width = 30;
    const height = 16;

    const style: React.CSSProperties = {
        width: `${width}px`,
        height: `${height}px`,
        position: "absolute",
        top: `calc(100% - ${height}px - ${margin[0]}px)`,
        left: `calc(100% - ${width}px - ${margin[1]}px)`,
        zIndex: 1000,
        textAlign: "center",
        fontSize: 9,
        padding: "1px 3px",
        backgroundColor: "hotpink",
        color: "white",
        ...styleProps,
    };

    return <div style={style}>{"EZB"}</div>;
};

export default memo(LessonBookingBadge);
